'use strict';
module.exports = require('@mindmup/mindmup-common/src/cognito-username-for-license');

